module.exports = __webpack_public_path__ + "static/media/warning.715f5d53.svg";